module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg8": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Descrição dos resultados do projeto de pesquisa",
      "value": this.projetoPesquisa.resultadosObtidos ? this.projetoPesquisa.resultadosObtidos : '-',
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), (_vm.listaArquivosFiltrada.length !== 0) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("Arquivos com resultados do projeto")])])], 1) : _vm._e(), _vm._v(" "), (_vm.listaArquivosFiltrada.length !== 0) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1 arquivos",
    attrs: {
      "headers": _vm.headersArquivos,
      "header-props": {
        sortIcon: null
      },
      "items": _vm.listaArquivosFiltrada,
      "items-per-page": -1,
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "item.nome",
      fn: function(props) {
        return [_c('a', {
          attrs: {
            "href": _vm.api_url + '/pesquisa/projetos/' + _vm.idProjetoPesquisa + '/arquivos/' + props.item.idArquivo
          }
        }, [_c('v-icon', [_vm._v("vertical_align_bottom")]), _vm._v(_vm._s(props.item.nome.trim()) + "\n              ")], 1)]
      }
    }], null, false, 2661201811)
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.listaArquivosFiltrada.length === 0) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Arquivos com resultados do projeto",
      "value": "-",
      "align": "justify"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toVoltar()
      }
    }
  }, [_vm._v("Voltar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toEditar()
      }
    }
  }, [_vm._v("Editar")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2af1de70","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pesquisa/resultados-obtidos.vue
// module id = 883
// module chunks = 0